import { gql } from 'graphql.macro';

export const GetGoodPracticeList = gql`
    query GetGoodPracticeRecords($request: ObservationFilterRequestInput) {
        goodPracticeRecords(request: $request) {
            observationId
            locationType
            locationTypeDescription
            offSiteLocation
            {
                customerSiteName
                locationDescription
            }
            depotPcId
            depotPC
            depotPcName
            divisionId
            divisionName
            regionId
            regionName
            sHEQManagerId
            sHEQManager
            observationCategoryId
            observationCategoryName
            observationCategoryNameDE
            whatHappened
            observationStatus
            incidentDate
        }
    }
`;
